var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Type } from 'class-transformer';
import { Column, CreateDateColumn, Entity, Index, ManyToOne, OneToMany, PrimaryColumn, UpdateDateColumn } from 'typeorm';
export var TestStatus;
(function (TestStatus) {
    TestStatus["DEFAULT"] = "DEFAULT";
    TestStatus["CRASHING"] = "CRASHING";
    TestStatus["UNREACHABLE"] = "UNREACHABLE";
    TestStatus["SKIPPED"] = "SKIPPED";
    TestStatus["BLOCKED"] = "BLOCKED";
})(TestStatus || (TestStatus = {}));
let Test = class Test {
    id;
    createdDate;
    updatedDate;
    name;
    target;
    actions;
    initScript;
    enabled;
    failures;
    project;
    status;
    runs;
};
__decorate([
    PrimaryColumn('uuid', { default: () => 'uuidv7()' }),
    __metadata("design:type", String)
], Test.prototype, "id", void 0);
__decorate([
    CreateDateColumn({ type: 'timestamptz' }),
    Type(() => Date),
    __metadata("design:type", Date)
], Test.prototype, "createdDate", void 0);
__decorate([
    UpdateDateColumn({ type: 'timestamptz' }),
    Type(() => Date),
    __metadata("design:type", Date)
], Test.prototype, "updatedDate", void 0);
__decorate([
    Column({ default: 'Default' }),
    __metadata("design:type", String)
], Test.prototype, "name", void 0);
__decorate([
    Column(),
    __metadata("design:type", String)
], Test.prototype, "target", void 0);
__decorate([
    Column({ nullable: true }),
    __metadata("design:type", String)
], Test.prototype, "actions", void 0);
__decorate([
    Column({ nullable: true }),
    __metadata("design:type", String)
], Test.prototype, "initScript", void 0);
__decorate([
    Column({ default: true }),
    __metadata("design:type", Boolean)
], Test.prototype, "enabled", void 0);
__decorate([
    Column({ default: 0 }),
    __metadata("design:type", Number)
], Test.prototype, "failures", void 0);
__decorate([
    Index(),
    ManyToOne('Project', (project) => project.tests, { nullable: false, onDelete: 'CASCADE' }),
    __metadata("design:type", Function)
], Test.prototype, "project", void 0);
__decorate([
    Index(),
    Column({ type: 'enum', enum: TestStatus, default: TestStatus.DEFAULT }),
    __metadata("design:type", String)
], Test.prototype, "status", void 0);
__decorate([
    OneToMany('TestRun', (run) => run.test),
    __metadata("design:type", Array)
], Test.prototype, "runs", void 0);
Test = __decorate([
    Entity()
], Test);
export { Test };
//# sourceMappingURL=data:application/json;base64,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